(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  function getVariants(item) {
    try {
      return JSON.parse(item.dataset.variants || '[]');
    } catch (e) {
      return [];
    }
  }

  function shopifyImageSrc(src, width) {
    if (!src) return src;
    // Insert _WIDTHx before the file extension: image.jpg -> image_238x.jpg
    return src.replace(/(\.[^.?]+)(\?|$)/, '_' + width + 'x$1$2');
  }

  function updateImage(item, variant) {
    var wrap = item.querySelector('.cart-upsell__image-wrap');
    var img = wrap && wrap.querySelector('.cart-upsell__image');
    if (!img) return;

    var newSrc = variant.featured_image
      ? shopifyImageSrc(variant.featured_image.src, 238)
      : wrap.dataset.defaultImage;

    if (!newSrc) return;
    img.src = newSrc;
    img.srcset = '';
    if (variant.featured_image) {
      img.alt = variant.featured_image.alt || '';
    }
  }

  function updateButton(item, variantId) {
    var btn = item.querySelector('.cart-upsell__add-btn');
    if (!btn) return;

    var variants = getVariants(item);
    var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
    if (!variant) return;

    btn.dataset.variantId = variant.id;

    var select = item.querySelector('.cart-upsell__select');
    var selectedOption = select && select.options[select.selectedIndex];
    var formattedPrice = selectedOption && selectedOption.dataset.price;
    var priceEl = btn.querySelector('.cart-upsell__add-price');
    if (priceEl && formattedPrice) priceEl.textContent = formattedPrice;

    if (variant.available) {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
    } else {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    }

    updateImage(item, variant);
  }

  function effectiveStoreId() {
    if (window.S2Pickup && typeof window.S2Pickup.getEffectiveStoreId === 'function') {
      return window.S2Pickup.getEffectiveStoreId();
    }
    try {
      var s = JSON.parse(localStorage.getItem('s2_pickup_store') || 'null');
      return (s && s.id) || null;
    } catch (e) {
      return null;
    }
  }

  function checkAvailable(variantId, storeId) {
    if (window.S2Pickup && typeof window.S2Pickup.isVariantAvailableAtStore === 'function') {
      return window.S2Pickup.isVariantAvailableAtStore(variantId, storeId);
    }
    return Promise.resolve(false);
  }

  function applyAvailableVariants(item, avail) {
    var select = item.querySelector('.cart-upsell__select');
    if (select) {
      if (select.__origHTML == null) select.__origHTML = select.innerHTML;
      var availIds = {};
      avail.forEach(function (v) { availIds[String(v.id)] = true; });
      var tmp = document.createElement('select');
      tmp.innerHTML = select.__origHTML;
      var keep = Array.prototype.filter.call(tmp.options, function (o) {
        return availIds[String(o.value)];
      });
      select.innerHTML = '';
      keep.forEach(function (o) { select.appendChild(o); });
      select.value = String(avail[0].id);
    }
    updateButton(item, avail[0].id);
  }

  function restoreItem(item) {
    item.hidden = false;
    var select = item.querySelector('.cart-upsell__select');
    if (select && select.__origHTML != null) {
      select.innerHTML = select.__origHTML;
      updateButton(item, select.value);
    }
  }

  function filterItem(item, storeId) {
    var variants = getVariants(item).filter(function (v) { return v.available; });
    if (!variants.length) { item.hidden = true; return Promise.resolve(false); }
    return Promise.all(
      variants.map(function (v) {
        return checkAvailable(v.id, storeId).then(function (ok) {
          return ok === true ? v : null;
        });
      })
    ).then(function (res) {
      var avail = res.filter(Boolean);
      if (!avail.length) { item.hidden = true; return false; }
      item.hidden = false;
      applyAvailableVariants(item, avail);
      return true;
    });
  }

  function filterUpsell() {
    var container = document.querySelector('.cart-upsell');
    if (!container) return;
    var storeId = effectiveStoreId();
    var items = Array.prototype.slice.call(
      container.querySelectorAll('.cart-upsell__item')
    );

    if (!storeId) {
      items.forEach(restoreItem);
      container.hidden = false;
      container.setAttribute('data-pickup-filtered', '');
      return;
    }

    if (!container.hasAttribute('data-pickup-filtered')) container.hidden = true;
    container.setAttribute('data-pickup-filtered', '');

    if (!items.length) { container.hidden = true; return; }

    Promise.all(items.map(function (li) { return filterItem(li, storeId); }))
      .then(function (results) {
        container.hidden = !results.some(Boolean);
      });
  }

  // Intercept upsell select changes in the capture phase — fires before CartItems.onChange
  // ever sees the event, regardless of re-renders. No re-binding needed.
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.cart-upsell__select')) return;
    e.stopPropagation();
    var item = e.target.closest('.cart-upsell__item');
    if (item) updateButton(item, e.target.value);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-upsell__add-btn');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('loading');

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = '';
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    } else {
      sections = 'cart-drawer';
    }

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);

    if (effectiveStoreId()) formData.append('properties[_fulfillment]', 'pickup');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('[cart-upsell] Add to cart error:', response.description);
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        } else {
          window.location = '/cart';
        }
      })
      .catch(function (e) { console.error('[cart-upsell]', e); })
      .finally(function () { btn.classList.remove('loading'); });
  });

  ['pickup:store-selected', 'pickup:store-cleared'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      var container = document.querySelector('.cart-upsell');
      if (container) container.removeAttribute('data-pickup-filtered');
      filterUpsell();
    });
  });

  var filterPending = false;
  new MutationObserver(function () {
    if (filterPending) return;
    filterPending = true;
    Promise.resolve().then(function () {
      filterPending = false;
      if (document.querySelector('.cart-upsell:not([data-pickup-filtered])')) {
        filterUpsell();
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

  filterUpsell();
})();
